import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5bd8a23a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5bd8a23a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd8a23a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bd8a23a')) {
      api.createRecord('5bd8a23a', component.options)
    } else {
      api.reload('5bd8a23a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5bd8a23a&scoped=true&", function () {
      api.rerender('5bd8a23a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/resetPassword/index.vue"
export default component.exports